export const NowLoading = () => {
  return <h2>Now Loading...</h2>;
};
